import { lazyNamed } from 'src/utils/lazyNamed.ts';

const Authentication = {
  Forms: {
    ChangePassword: lazyNamed(() => import('./forms/ChangePassword/index.tsx'), 'ChangePassword'),
    ActivateUser: lazyNamed(() => import('./forms/ActivateUser/index.tsx'), 'ActivateUser'),
  },
  Components: {
    Layout: lazyNamed(() => import('./components/Layout/index.tsx'), 'Layout'),
    AppLogin: lazyNamed(() => import('./components/AppLogin.tsx'), 'AppLogin'),
    SSO: lazyNamed(() => import('./components/SSO.tsx'), 'SSO'),
    Autologin: lazyNamed(() => import('./components/Autologin.tsx'), 'Autologin'),
    McpSessionGuard: lazyNamed(() => import('./components/McpSessionGuard.tsx'), 'McpSessionGuard'),
    McpAuthorize: lazyNamed(() => import('./components/McpAuthorize.tsx'), 'McpAuthorize'),
  },
};

export default Authentication;
